import useSWR from "@/hooks/useSWR";
import { PlanIdTypeSafe } from "@/types/PlanTypes";
import { ProxyConfigStatusType } from "@/types/ProxyConfigurationTypes";
import { urlWithPlanId } from "@/utils/toPlanId";
import useSubuserId from "./useSubuserId";
import type { SWRConfiguration } from "swr";
import usePlan from "./usePlan";

export default function useProxyStatus(
  planId: PlanIdTypeSafe,
  enabled: boolean = true,
  options?: SWRConfiguration<ProxyConfigStatusType>
) {
  const subuser_id = useSubuserId();
  const plan = usePlan(planId, !subuser_id);

  const url = !subuser_id
    ? urlWithPlanId("/proxy/list/status", {
        plan_id: plan.data?.id || planId,
      })
    : `/proxy/list/status?subuser_id=${subuser_id}`;

  return useSWR<ProxyConfigStatusType>(
    !url
      ? null
      : {
          url,
          apiVersion: "v3",
          enabled,
        },
    options
  );
}
